import { compose, head, is, prop, split } from 'ramda'
import queryString from 'query-string'

export const forceAppendQueryParams = (value, label) => {
  const loc = window.location
  const url = new URL(loc.href)
  url.searchParams.append(value, label)
  window.location = url
}

export const prepareQueryParams = (key, value) => {
  const qp = getQueryParams()
  qp[key] = value
  return queryString.stringify(qp)
}

export const prepareJsonQueryParams = (key, value) => {
  try {
    const jsonValue = JSON.stringify(value)
    return prepareQueryParams(key, jsonValue)
  } catch (e) {
    return prepareQueryParams(key, undefined)
  }
}

export const setQueryParams = (key, value) => {
  const params = prepareQueryParams(key, value)
  // window.location.search = params
  // history.replaceState(null, null, '?' + params)
}

export const getJsonQueryParam = key => {
  try {
    return JSON.parse(getQueryParam(key) || {})
  } catch {
    return undefined
  }
}

export const getQueryParam = key => {
  const qp = getQueryParams()
  const value = prop(key, qp)
  return is(Array, value) ? head(value) : value
}

export const getQueryParams = () => {
  const loc = window.location
  return queryString.parse(loc?.search)
}

export const getSubdomain = () => {
  // Ephemeral PR environments that have no paired back-elixir deploy build
  // against a stable shared backend (DEFAULT_BACK_URL, see
  // .github/workflows/ephemeral-deploy.yaml) instead of their own - that
  // backend's own real workspace name has nothing to do with this front
  // build's own *.fly.dev hostname, so a build-time override wins over the
  // hostname-derived value when present. Unset for every other build
  // (paired ephemeral, local dev, real deploys), which keeps the existing
  // hostname-based behavior exactly as it was.
  if (process.env.REACT_APP_WORKSPACE_OVERRIDE) {
    return process.env.REACT_APP_WORKSPACE_OVERRIDE
  }

  const loc = window.location
  return compose(head, split('.'))(loc.hostname)
}

export const getDomainWithoutWorkspace = url => {
  const loc = window.location
  url = url || loc.host
  const urlParts = url.split('.')

  return urlParts
    .slice(0)
    .slice(-(urlParts.length === 4 ? 3 : 2))
    .join('.')
}
